import { Component, Input } from '@angular/core';
import { Dialog } from 'primeng/dialog';

@Component({
  selector: 'm-modal',
  templateUrl: './m-modal.component.html',
  styleUrls: ['./m-modal.component.scss']
})
export class MModalComponent extends Dialog {
  @Input() isFullscreen = false;
  @Input() isMaximized = false;
  @Input() override showHeader = true;
  @Input() showFooter = true;
}
